import React, { useEffect } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
} from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import styles from "./Addons.module.scss";
import { updateSponsorAction } from "../../../../../../redux/services/ads-and-addons-services/adsAndAddonsServices";
import { useDispatch, useSelector } from "react-redux";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { updateKeyValueAction } from "../../../../../../redux/services/common/commonServices";

const Addons = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch dependencies */
  const dispatch = useDispatch();
  /* dispatch dependencies */

  const navigate = useNavigate();

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const type = Form.useWatch("type", { form, preserve: true });
  const initialValues = {
    type: null,
    price: "",
    duration: null,
  };
  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
  /* form dependencies */

  useEffect(() => {
    dispatch(getSystemSettingsAction(setLoading));
  }, []);

  /* reset default form fields */
  const resetDefaultFields = () => {
    form.setFieldsValue({
      price: initialValues.price,
      duration: initialValues.duration,
    });
  };
  /* reset default form fields */

  const handleViewList = () => {
    navigate(baseRouteMakerForSuperAdmin(routes.ADDONS_LIST));
  };

  const onSubmit = (values) => {
    const { price, ...rest } = values;
    if(values?.type === "addon") {
      const dataToBeSentForAddonLogin = {
        ...rest,
        price: Number(price),
        duration_unit: "month",
        currency: systemSettings?.system_currency,
      };
  
      dispatch(updateSponsorAction(dataToBeSentForAddonLogin));
    }
    else if(values?.type === "push_notification") {
      const dataToBeSentForPushNotification = {
        single_push_notification_send_charges : Number(price)
      }
      dispatch(updateKeyValueAction(dataToBeSentForPushNotification, setLoading))
    }
    resetDefaultFields();
  };

  return (
    <div className={styles.addonsContainer}>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={onSubmit}
        initialValues={initialValues}
      >
        <Row gutter={[24, 24]}>
          <Col span={22}>
            <Form.Item
              name="type"
              rules={[
                {
                  required: true,
                  message: t("Modules.Addons.pleaseSelectTopListings"),
                },
              ]}
            >
              <Radio.Group onChange={()=>{
                form.setFieldValue("duration", null);
              }}>
                <Radio value="addon">{t("Modules.Addons.addonLogins")}</Radio>
                <Radio value="push_notification">
                  {t("Modules.Addons.pushNotification")}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Button
              type="primary"
              loading={loading}
              disabled={loading}
              style={{ marginTop: "10px" }}
              onClick={(e) => handleViewList(e)}
            >
              {t("CommonUtils.logs")}
            </Button>
          </Col>
          <Col span={8}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.Services.ServicesForm.price")}
                  required={true}
                />
              }
              name="price"
              rules={[
                {
                  required: true,
                  message: t("Modules.Services.ServicesForm.pleaseEnterPrice"),
                },
                {
                  validator: (_, value) => {
                    if (value && value < 1)
                      return Promise.reject(
                        `${t("Modules.Services.ServicesForm.price")} ${t(
                          "CommonUtils.shouldBeGreaterThan0"
                        )}`
                      );
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                type="number"
                placeholder={t("Modules.Services.ServicesForm.enterPrice")}
                onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </Form.Item>
          </Col>
              {
                type !== "push_notification" ?
                <Col span={8}>
                  <Form.Item
                    name="duration"
                    label={
                      <RequiredLabel text={t("Modules.Ads.period")} required={true} />
                    }
                    rules={[
                      {
                        required: type !== "push_notification" ? true : false,
                        message: t("Modules.Ads.pleaseSelectPeriod"),
                      },
                    ]}
                  >
                    <Select
                      loading={selectListLoader}
                      options={[
                        { value: 1, label: "01 month" },
                        { value: 4, label: "04 months" },
                        { value: 6, label: "06 months" },
                        { value: 12, label: "12 months" },
                      ]}
                      placeholder={t("Modules.Ads.selectPeriod")}
                    />
                  </Form.Item>
                </Col>
                :
                <></>
              }
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
              style={{ marginTop: "10px" }}
            >
              {t("CommonUtils.submit")}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Addons;
